import {
  GET_ALL_PRODUCT_SLOC,
  GET_PRODUCT_BY_FILTER,
  GetListAgeCbx,
  GetListBatchComboboxQuery,
  GetListCMDCbx,
  GetListSlocCbxQuery,
} from 'apis/GraphQL/Queries/productQuery';
import axiosGraphQL from './GraphQL/axiosGraphQL';
import { PRODUCT_VARIABLE } from './GraphQL/Variables/product';

const ProductApi = {
  getProductSlocList: async (params: any) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_ALL_PRODUCT_SLOC,
      variables: PRODUCT_VARIABLE.getProductSloc(params),
    });
  },

  getProductByFilter: async (params: any) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_PRODUCT_BY_FILTER,
      variables: PRODUCT_VARIABLE.getProductByFilter(params),
    });
  },

  getProduct: async (params: any) => {
    return await axiosGraphQL.post('/graphql', {
      query: `query GetProduct($input: GetAllProductInput, $skip: Float, $take: Float){
    getAllProduct(where: $input,skip: $skip, take: $take) {
        pageInfo{
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
        }
      items{
        id
        name
        age
        collection
        commodityLine
        mrpId
        mrpName
        species
        unit
        type
        urlImage
        urlImage1
        urlImage2
        urlImage3
        urlImage4
        urlImage5
        ttype{
            id
            name
            note
            status
        }
      tcreateUser{
                    fullName
                }
                createDate
                tmodifyUser{
                    fullName
                }
                modifyDate
            
       
      }
  }
}`,
      variables: PRODUCT_VARIABLE.getProduct(params),
    });
  },

  getAgeCombobox: async (params: { pageSize: number; age?: number }) => {
    return await axiosGraphQL.post('/graphql', {
      query: GetListAgeCbx,
      variables: PRODUCT_VARIABLE.getListAgeCbxVariables(params),
    });
  },

  getCollectionCombobox: async () => {
    return await axiosGraphQL.post('/graphql', {
      query: `query GetListAgeComboBox($input:TproductWhereInput){
    getProduct(where:$input,groupBy:[collection]){
        items{
            collection
        }
    }
}`,
      variables: {
        input: {
          collection: { not: '' },
        },
      },
    });
  },

  getSlocCombobox: async (params: { pageSize: number; sloc?: string }) => {
    return await axiosGraphQL.post('/graphql', {
      query: GetListSlocCbxQuery,
      variables: PRODUCT_VARIABLE.getListSlocCbxVariables(params),
    });
  },

  getBatchCombobox: async (params: { pageSize: number; batch?: string }) => {
    return await axiosGraphQL.post('/graphql', {
      query: GetListBatchComboboxQuery,
      variables: PRODUCT_VARIABLE.getListBatchComboboxVariables(params),
    });
  },

  getCommodityLineCombobox: async (params: {
    pageSize: number;
    batch?: string;
  }) => {
    return await axiosGraphQL.post('/graphql', {
      query: GetListCMDCbx,
      variables: PRODUCT_VARIABLE.getListCMDCbxVariables(params),
    });
  },

  getGroupPriceCombobox: async () => {
    return await axiosGraphQL.post('/graphql', {
      query: `query GetGroupPriceComboBox($input:TMarketGoldPriceWhereInput,$skip:Float,$take:Float){
    getMarketGoldPrice(where:$input,skip:$skip,take:$take,groupBy:[groupPrice]){
        items{
            groupPrice
        }
    }
}`,
      variable: {
        input: {
          groupPrice: { not: '' },
        },
      },
    });
  },
};

export default ProductApi;
